import { Box, Divider, Grid} from "@mui/material";
import { MenusProps } from "../"
import { escurecerCor } from "../../../../helpers/manipulacaoCores"
import { colors } from "../../bannerColors"
import TemplateOpcoes from "../../Templates/TemplateOpcoes"
import AddIcon from '@mui/icons-material/Add';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import { useNavigate } from "react-router-dom";
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import { useModalStateContext } from "../../../../contexts/ModalStateContext";
import { usePermission } from "../../../PermissionGuard";

export default function CadastrosMenu({ type }: MenusProps) {

    const navigate = useNavigate();
    const { handleToggleModal } = useModalStateContext();

    const color = colors[type] || "#1E2E6B"
    const textColor = escurecerCor(color)

    const handleRedirect = (path: string) => {
        navigate(`/cadastros/${path}`)
    }

    return (
        <Box>
            <Grid container spacing={2}>

                <TemplateDashboardComOpcoes
                    {...{ type }}
                    color={textColor}
                    items={[]}
                />

                <Divider orientation="vertical" sx={{ border: '1px solid', borderColor: 'divider', }} flexItem />

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Cooperado"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir cooperado",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => {handleToggleModal("cadastros", "incluirCooperado", true)},
                                disabled: !usePermission("cadastros.cooperado.incluir")
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("cooperado/listar-todos"),
                                disabled: !usePermission("cadastros.cooperado.listar-todos")
                            }
                        ]}
                    />

                    <TemplateOpcoes
                        title="Cliente"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir cliente",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("cliente/listar-todos"),
                                disabled: !usePermission("cadastros.cliente.listar-todos")
                            },
                        ]}
                    />
                </Grid>

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Fornecedor"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir fornecedor",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("fornecedor/listar-todos"),
                                disabled: !usePermission("cadastros.fornecedor.listar-todos")
                            },
                        ]}
                    />

                    <TemplateOpcoes
                        title="Empregado"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir empregado",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("empregado/listar-todos"),
                                disabled: !usePermission("cadastros.empregado.listar-todos")
                            },
                        ]}
                    />
                </Grid>

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Loja"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir loja",  
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => {  },
                                disabled: true
                            },
                            {
                                label: "Listar todas",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("loja/listar-todas"),
                                disabled: !usePermission("cadastros.loja.listar-todas")
                            },
                        ]}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

